import uniqueId from 'lodash/uniqueId';

// TODO: write explanation and unit tests

export const MSG_SET_MESSAGE = (state, { message }) => ({
  ...state,
  [message.type]: [
    ...(state[message.type] ? state[message.type] : []),
    {
      id: uniqueId(),
      success: message.success,
      title: message.title,
      details: message.details
    }
  ]
});

export const MSG_CLEAR_MESSAGE = (state, { clearMessage }) => ({
  ...state,
  [clearMessage.type]: [...state[clearMessage.type]].filter((msg) => msg.id !== clearMessage.id)
});

export const MSG_CLEAR_MESSAGES = () => ({});
